import { useEffect, useState } from "react";
import { toast } from "sonner";
import FieldEditor from "./FieldEditor";
import ReviewPanel from "./ReviewPanel";

export default function ItemEditor({ api, id, opts, onChanged }) {
  const [data, setData] = useState(null);
  const [fields, setFields] = useState({});
  const [saving, setSaving] = useState(false);

  const load = () => api.get(`/admin/starter-kit/items/${id}`).then((r) => { setData(r.data); setFields(r.data.fields); });
  useEffect(() => { load(); }, [id]);

  const save = async () => {
    setSaving(true);
    try {
      await api.patch(`/admin/starter-kit/items/${id}`, { fields });
      toast.success("Saved — item is back to draft until re-approved.");
      await load(); onChanged();
    } catch (e) { toast.error(e.response?.data?.detail || "Save failed"); }
    finally { setSaving(false); }
  };
  const refresh = async () => { await load(); onChanged(); };

  if (!data) return <p className="px-3 py-3 text-sm text-[#6E6E6E]">Loading…</p>;
  const it = data.item;
  return (
    <div className="bg-[#FBF9F5] px-4 py-4 space-y-4 border-t-2 border-[#EDE8DC]" data-testid={`sk-editor-${id}`}>
      <p className="text-xs font-[IBM_Plex_Mono] text-[#6E6E6E]">{it.id} · {it.sports.join(", ")} · ages {it.age_groups.join(", ")} · v{it.version}</p>
      {data.reject_reason && <p className="text-sm text-[#B3261E]">Rejected: {data.reject_reason}</p>}
      {data.blocks && (
        <div className="text-xs font-[IBM_Plex_Mono] text-[#1E1E1E]">
          <p className="uppercase text-[#6E6E6E] mb-1">Timeline ({data.length} min)</p>
          {data.blocks.map(([b, m], i) => <span key={i} className="inline-block mr-2 mb-1 border border-[#D3CFC0] px-1.5">{b.split("_").slice(1).join("_")} {m}'</span>)}
        </div>
      )}
      {Object.entries(data.kinds).map(([k, kind]) => (
        <FieldEditor key={k} name={k} kind={kind} value={fields[k]} onChange={(v) => setFields((f) => ({ ...f, [k]: v }))} />
      ))}
      <div className="flex flex-wrap gap-2 items-center">
        {Object.keys(data.kinds).length > 0 && (
          <button data-testid="sk-item-save" disabled={saving} onClick={save}
            className="px-4 py-1.5 font-head uppercase text-sm bg-[#1E1E1E] text-[#F3F1EC] disabled:opacity-50 hover:bg-[#DB9130] hover:text-[#1E1E1E] transition-colors">
            {saving ? "Saving…" : "Save edits"}
          </button>
        )}
      </div>
      <ReviewPanel api={api} item={it} opts={opts} onDone={refresh} />
    </div>
  );
}
